// АВТОГЕНЕРИРОВАНО – не редактировать руками.
// Источник: src/icons/svg/*.svg. Перегенерировать: npm run icons:build (в apps/web).
// Генератор: scripts/generate-icons.mjs.

export const ICON_PATHS = {
  alertCircle: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M12 8v4.5M12 15.7h.01" />
      </>
    ),
  },
  alertTriangle: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <path d="M12 4l9.3 16H2.7z" />
        <path d="M12 10v4.3M12 17.3h.01" />
      </>
    ),
  },
  bell: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <path d="M18 16v-5a6 6 0 00-12 0v5l-1.5 2.5h15z" />
        <path d="M10 19a2 2 0 004 0" />
      </>
    ),
  },
  calendar: {
    fill: 'none',
    strokeWidth: 2,
    children: (
      <>
        <rect x="3" y="5" width="18" height="16" rx="2" />
        <path d="M16 3v4M8 3v4M3 10h18" />
      </>
    ),
  },
  check: {
    fill: 'none',
    strokeWidth: 2.2,
    children: (
      <>
        <path d="M20 6L9 17l-5-5" />
      </>
    ),
  },
  chevronDown: {
    fill: 'none',
    strokeWidth: 2,
    children: (
      <>
        <path d="M6 9l6 6 6-6" />
      </>
    ),
  },
  chevronLeft: {
    fill: 'none',
    strokeWidth: 2,
    children: (
      <>
        <path d="M15 6l-6 6 6 6" />
      </>
    ),
  },
  chevronRight: {
    fill: 'none',
    strokeWidth: 2,
    children: (
      <>
        <path d="M9 6l6 6-6 6" />
      </>
    ),
  },
  clock: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M12 7.5V12l3 2" />
      </>
    ),
  },
  close: {
    fill: 'none',
    strokeWidth: 2.2,
    children: (
      <>
        <path d="M6 6l12 12M18 6L6 18" />
      </>
    ),
  },
  compass: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M15.5 8.5L13 13l-4.5 2.5L11 11l4.5-2.5z" />
      </>
    ),
  },
  dashboard: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <rect x="3.5" y="3.5" width="7.5" height="7.5" rx="1.7" />
        <rect x="13" y="3.5" width="7.5" height="4.5" rx="1.7" />
        <rect x="13" y="10.5" width="7.5" height="10" rx="1.7" />
        <rect x="3.5" y="13.5" width="7.5" height="7" rx="1.7" />
      </>
    ),
  },
  externalLink: {
    fill: 'none',
    strokeWidth: 1.9,
    children: (
      <>
        <path d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4" />
        <path d="M14 4h6v6" />
        <path d="M20 4L10 14" />
      </>
    ),
  },
  eye: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z" />
        <circle cx="12" cy="12" r="2.7" />
      </>
    ),
  },
  eyeOff: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <path d="M9.9 5.8A9.6 9.6 0 0 1 12 5.5c6 0 9.5 6.5 9.5 6.5a17 17 0 0 1-3.3 4.2" />
        <path d="M6.4 7.6A16.7 16.7 0 0 0 2.5 12S6 18.5 12 18.5c1.7 0 3.2-.5 4.5-1.2" />
        <path d="M10 10a2.7 2.7 0 0 0 3.8 3.8" />
        <path d="M4 4l16 16" />
      </>
    ),
  },
  fileText: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <path d="M6.5 3.5h8L19 8v12a1.3 1.3 0 01-1.3 1.3H6.5A1.3 1.3 0 015.2 20V4.8A1.3 1.3 0 016.5 3.5z" />
        <path d="M14 3.5V8h4.7" />
        <path d="M8.3 12.5h7.2M8.3 15.7h7.2M8.3 18.4h4.4" />
      </>
    ),
  },
  flask: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <path d="M9 3.5h6M9.5 3.5v3.8L5.6 15.4a2 2 0 001.8 2.9h9.2a2 2 0 001.8-2.9L14.5 7.3V3.5" />
        <path d="M7.5 13.5h9" />
      </>
    ),
  },
  gearSpark: {
    fill: 'none',
    strokeWidth: 1.5,
    children: (
      <>
        <line x1="12" y1="11" x2="18.4" y2="11" />
        <line x1="12" y1="11" x2="16.53" y2="15.53" />
        <line x1="12" y1="11" x2="12" y2="17.4" />
        <line x1="12" y1="11" x2="7.47" y2="15.53" />
        <line x1="12" y1="11" x2="5.6" y2="11" />
        <line x1="12" y1="11" x2="7.47" y2="6.47" />
        <line x1="12" y1="11" x2="12" y2="4.6" />
        <line x1="12" y1="11" x2="16.53" y2="6.47" />
        <line x1="18.4" y1="11" x2="20" y2="11" />
        <line x1="16.53" y1="15.53" x2="17.66" y2="16.66" />
        <line x1="12" y1="17.4" x2="12" y2="19" />
        <line x1="7.47" y1="15.53" x2="6.34" y2="16.66" />
        <line x1="5.6" y1="11" x2="4" y2="11" />
        <line x1="7.47" y1="6.47" x2="6.34" y2="5.34" />
        <line x1="12" y1="4.6" x2="12" y2="3" />
        <line x1="16.53" y1="6.47" x2="17.66" y2="5.34" />
        <circle cx="12" cy="11" r="6.4" />
        <circle cx="12" cy="11" r="1" fill="currentColor" stroke="none" />
        <line x1="13.1" y1="9.9" x2="14.1" y2="8.9" />
        <line x1="10.9" y1="9.9" x2="9.9" y2="8.9" />
        <line x1="13.1" y1="12.1" x2="14.1" y2="13.1" />
        <line x1="10.9" y1="12.1" x2="9.9" y2="13.1" />
      </>
    ),
  },
  gift: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <rect x="4" y="9" width="16" height="4" rx="1" />
        <rect x="5.5" y="13" width="13" height="7.5" rx="1" />
        <path d="M12 9v11.5" />
        <path d="M12 9c-1.2 0-3-1-3-2.8A2.2 2.2 0 0111.2 4c1.8 0 2.8 2.5 2.8 5M12 9c1.2 0 3-1 3-2.8A2.2 2.2 0 0012.8 4C11 4 10 6.5 10 9" />
      </>
    ),
  },
  image: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <rect x="3" y="4.5" width="18" height="15" rx="2" />
        <circle cx="8.5" cy="9.5" r="1.5" />
        <path d="M3 16.5l4.5-4a1.5 1.5 0 012 0L14 17" />
        <path d="M13.5 14.5l1.8-1.6a1.5 1.5 0 012 0L21 16" />
      </>
    ),
  },
  kebab: {
    fill: 'currentColor',
    strokeWidth: 0,
    children: (
      <>
        <circle cx="12" cy="5.5" r="1.7" />
        <circle cx="12" cy="12" r="1.7" />
        <circle cx="12" cy="18.5" r="1.7" />
      </>
    ),
  },
  lock: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <rect x="3.3" y="10.5" width="17.4" height="10.4" rx="1.8" />
        <path d="M7.2 10.5V7a4.8 4.8 0 0 1 9.6 0v3.5" />
      </>
    ),
  },
  lockOpen: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <rect x="3.3" y="10.5" width="17.4" height="10.4" rx="1.8" />
        <path d="M7.2 10.5V7a4.8 4.8 0 0 1 9.5-1" />
      </>
    ),
  },
  mail: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <rect x="3.3" y="5.3" width="17.4" height="13.4" rx="1.8" />
        <path d="M4 6.5l8 6 8-6" />
      </>
    ),
  },
  megaphone: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <path d="M3.5 10.5v3l14.5 4.5V6L3.5 10.5z" />
        <path d="M11.4 16.6a3 3 0 11-5.6-1.7" />
        <path d="M21 10.5v3" />
      </>
    ),
  },
  pencil: {
    fill: 'none',
    strokeWidth: 1.85,
    children: (
      <>
        <path d="M16.5 4.5l3 3L8 19l-4 1 1-4z" />
      </>
    ),
  },
  phone: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <path d="M6.6 3.8h3l1.4 4.5-2 1.6a12 12 0 005.6 5.6l1.6-2 4.5 1.4v3a1.6 1.6 0 01-1.7 1.6C10.6 19 5 13.4 5 5.5a1.6 1.6 0 011.6-1.7z" />
      </>
    ),
  },
  plus: {
    fill: 'none',
    strokeWidth: 2.2,
    children: (
      <>
        <path d="M12 5v14M5 12h14" />
      </>
    ),
  },
  psi: {
    fill: 'none',
    strokeWidth: 1.9,
    children: (
      <>
        <path d="M12 3.5v17" />
        <path d="M4.5 4c0 5.5 2.5 9 7.5 9" />
        <path d="M19.5 4c0 5.5-2.5 9-7.5 9" />
        <path d="M8 20.5h8" />
      </>
    ),
  },
  reports: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <path d="M4.5 20V4.8A1.3 1.3 0 015.8 3.5h8.7L19 8v12a1.3 1.3 0 01-1.3 1.3H5.8A1.3 1.3 0 014.5 20z" />
        <path d="M8.3 12h7.2M8.3 15.4h7.2M8.3 8.6h3.2" />
      </>
    ),
  },
  search: {
    fill: 'none',
    strokeWidth: 2,
    children: (
      <>
        <circle cx="11" cy="11" r="7" />
        <path d="M21 21l-4.3-4.3" />
      </>
    ),
  },
  settings: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915" />
        <circle cx="12" cy="12" r="3" />
      </>
    ),
  },
  shield: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <path d="M12 3.5l7 2.7v5.6c0 4.6-3 7.7-7 8.7-4-1-7-4.1-7-8.7V6.2z" />
        <path d="M9.2 12l2 2 3.6-4" />
      </>
    ),
  },
  square: {
    fill: 'none',
    strokeWidth: 2,
    children: (
      <>
        <path d="M4 4h16v16H4z" />
      </>
    ),
  },
  support: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <circle cx="12" cy="12" r="8.5" />
        <circle cx="12" cy="12" r="3.2" />
        <path d="M6.2 6.2l3.3 3.3M17.8 6.2l-3.3 3.3M6.2 17.8l3.3-3.3M17.8 17.8l-3.3-3.3" />
      </>
    ),
  },
  testChecklist: {
    fill: 'none',
    strokeWidth: 1.6,
    children: (
      <>
        <rect x="4.5" y="4" width="13" height="16.5" rx="1.8" />
        <rect x="8.7" y="2.2" width="4.2" height="2.6" rx="1" />
        <rect x="6.8" y="8.6" width="1.8" height="1.8" rx="0.3" />
        <line x1="10" y1="9.5" x2="14.5" y2="9.5" />
        <rect x="6.8" y="12.2" width="1.8" height="1.8" rx="0.3" />
        <line x1="10" y1="13.1" x2="14.5" y2="13.1" />
        <rect x="6.8" y="15.8" width="1.8" height="1.8" rx="0.3" />
        <line x1="10" y1="16.7" x2="13" y2="16.7" />
        <circle cx="17" cy="18.5" r="3.3" fill="currentColor" stroke="none" />
        <path d="M15.5 18.5l1 1 1.9-2.2" stroke="white" strokeWidth="1.4" />
      </>
    ),
  },
  trash: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <path d="M4 7h16" />
        <path d="M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3" />
        <path d="M6 7l1 12a2 2 0 002 2h6a2 2 0 002-2l1-12" />
        <path d="M10 11v6M14 11v6" />
      </>
    ),
  },
  user: {
    fill: 'none',
    strokeWidth: 1.9,
    children: (
      <>
        <circle cx="12" cy="8" r="3.6" />
        <path d="M4.5 20c0-4.1 3.4-7 7.5-7s7.5 2.9 7.5 7" />
      </>
    ),
  },
  userPlus: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <circle cx="10" cy="8" r="3.2" />
        <path d="M3.5 19c0-3.3 3-5.5 6.5-5.5s6.5 2.2 6.5 5.5" />
        <path d="M18.5 8v5M16 10.5h5" />
      </>
    ),
  },
  users: {
    fill: 'none',
    strokeWidth: 1.75,
    children: (
      <>
        <circle cx="9" cy="8" r="3.2" />
        <path d="M3.5 19c0-3.3 2.5-5.5 5.5-5.5s5.5 2.2 5.5 5.5" />
        <circle cx="17" cy="8.5" r="2.4" />
        <path d="M15.8 13.7c2.4.3 4.2 2.2 4.2 5" />
      </>
    ),
  },
} as const;
